// Every string AssetTile renders of its own, and the shape a caller may replace
// them with.
//
// The mechanism is BidCard's exactly — one object of finished text in one
// language, merged over these defaults key by key, with an UNKNOWN key rejected
// because that is the failure that renders English forever with nothing saying
// why. The reasoning is written out once, in bidCardTranslations.js.
//
// Deliberately NOT exported from the package barrel: the catalog gate holds that
// a barrel exports components and nothing else.

import { unreadTranslationKeys as unreadKeysAgainst } from './bidCardTranslations';

/**
 * The English defaults, frozen.
 */
export const ASSET_TILE_TRANSLATIONS = Object.freeze({
  // The label before the asset's MMR on a featured tile: "MMR $36,200".
  mmr: 'MMR',
  // Browse like toggle: accessible name when the asset is not liked yet.
  like: 'Like',
  // Browse like toggle: accessible name when the asset is already liked.
  liked: 'Liked',
});

/**
 * The keys in `translations` that AssetTile would not read, as dotted paths.
 */
export const unreadTranslationKeys = (translations) =>
  unreadKeysAgainst(translations, ASSET_TILE_TRANSLATIONS);

/** One language's text over the English defaults, key by key. */
export function mergeTranslations(translations) {
  if (!translations) {
    return ASSET_TILE_TRANSLATIONS;
  }

  return { ...ASSET_TILE_TRANSLATIONS, ...translations };
}

/**
 * The `i18n` prop's validator, AssetTile's and AssetRail's: `{ translations }`,
 * optional.
 */
export function isValidAssetTileI18n(i18n) {
  if (i18n === null || typeof i18n !== 'object') {
    return false;
  }
  if (Object.keys(i18n).some((key) => key !== 'translations')) {
    return false;
  }
  if (i18n.translations === undefined) {
    return true;
  }
  return unreadTranslationKeys(i18n.translations).length === 0;
}
